import { LegalPage, LegalSection } from "@/components/LegalPage";
import { CONTACT } from "@/data/site";

const Terms = () => (
  <LegalPage
    testid="terms-page"
    overline="Informații Legale"
    title="Termeni și Condiții"
    updated="octombrie 2026"
  >
    <LegalSection title="1. Serviciile noastre">
      <p>
        Velierul Hope oferă experiențe cu velierul Jeanneau Sun Odyssey 42.2
        „Hope", cu plecare din {CONTACT.location}: nunți și evenimente private,
        cursuri practice de navigație (skipper training), excursii la Balcik,
        croaziere la apus, croaziere de mai multe zile, programe de team
        building și participare la sezonul de regate. Toate ieșirile se fac cu
        skipper autorizat la bord.
      </p>
    </LegalSection>

    <LegalSection title="2. Rezervări și plată">
      <p>
        Rezervarea se face prin formularul de pe site, prin WhatsApp sau
        telefonic. O dată devine fermă abia după confirmarea disponibilității
        și achitarea avansului stabilit în ofertă. Tarifele afișate pe site
        sunt orientative („de la") — oferta finală depinde de dată, durată,
        numărul de persoane și serviciile alese.
      </p>
    </LegalSection>

    <LegalSection title="3. Vremea și anulările">
      <p>
        Siguranța primează întotdeauna: skipperul poate amâna sau modifica o
        ieșire din cauza condițiilor meteo. În acest caz, îți oferim
        reprogramare gratuită sau returnarea integrală a avansului dacă nu
        găsim împreună o altă dată. La anularea din partea ta cu cel puțin 14
        zile înainte, avansul se returnează integral; pentru anulări mai
        târzii, stabilim împreună o soluție corectă.
      </p>
    </LegalSection>

    <LegalSection title="4. Reguli la bord">
      <p>
        La bord se respectă instrucțiunile skipperului în orice moment.
        Copiii sunt bineveniți sub supravegherea unui adult; vestele de
        salvare sunt disponibile pentru toți oaspeții și obligatorii pentru
        copii. Consumul de alcool este permis cu măsură, mai puțin pentru
        cei care participă activ la manevre.
      </p>
    </LegalSection>

    <LegalSection title="5. Limitarea răspunderii">
      <p>
        Participarea la activitățile nautice presupune un risc minim inerent.
        Nu ne asumăm răspunderea pentru obiecte personale pierdute la bord sau
        pentru întârzieri cauzate de condiții meteo sau de traficul portuar.
      </p>
    </LegalSection>

    <LegalSection title="6. Soluționarea litigiilor">
      <p>
        Orice neînțelegere încercăm mai întâi să o rezolvăm amiabil — scrie-ne
        la <a href={CONTACT.emailHref} className="text-gold">{CONTACT.email}</a>{" "}
        și îți răspundem în cel mult 30 de zile. Dacă nu ajungem la o soluție,
        poți apela la:
      </p>
      <p className="mt-3">
        <strong className="text-ivory">ANPC — SAL</strong> (Soluționarea
        Alternativă a Litigiilor):{" "}
        <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="noopener noreferrer" className="text-gold">
          https://anpc.ro/ce-este-sal/
        </a>
      </p>
      <p className="mt-3">
        <strong className="text-ivory">Platforma SOL</strong> a Comisiei
        Europene (soluționarea online a litigiilor):{" "}
        <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-gold">
          https://ec.europa.eu/consumers/odr
        </a>
      </p>
      <p className="mt-3">
        Litigiile pot fi, de asemenea, soluționate de instanțele judecătorești
        competente din România.
      </p>
    </LegalSection>
  </LegalPage>
);

export default Terms;
